export type WeatherVisual = {
  label: string;
  icon: string;
};

export function getWeatherVisual(code: number, isDay: boolean): WeatherVisual {
  if (code === 0) {
    return isDay
      ? { label: "Clear", icon: "clear-day" }
      : { label: "Clear", icon: "clear-night" };
  }

  if (code === 1 || code === 2) {
    return isDay
      ? { label: "Partly cloudy", icon: "partly-cloudy-day" }
      : { label: "Partly cloudy", icon: "partly-cloudy-night" };
  }

  if (code === 3) {
    return { label: "Overcast", icon: "cloudy" };
  }

  if (code === 45 || code === 48) {
    return { label: "Fog", icon: "fog" };
  }

  if ([51, 53, 55, 56, 57].includes(code)) {
    return { label: "Drizzle", icon: "drizzle" };
  }

  if ([61, 63, 65, 66, 67, 80, 81, 82].includes(code)) {
    return { label: "Rain", icon: "rain" };
  }

  if ([71, 73, 75, 77, 85, 86].includes(code)) {
    return { label: "Snow", icon: "snow" };
  }

  if ([95, 96, 99].includes(code)) {
    return { label: "Thunderstorm", icon: "thunder" };
  }

  return { label: "Weather", icon: "cloudy" };
}
